import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import FlashFeed from '@/pages/home/components/FlashFeed';
import DeepDive from '@/pages/home/components/DeepDive';
import ChannelGrid from '@/pages/home/components/ChannelGrid';
import PusherMap from '@/pages/home/components/PusherMap';
import VoiceWall from '@/pages/home/components/VoiceWall';
import SubscribeCta from '@/pages/home/components/SubscribeCta';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 font-body text-foreground-900">
      <SiteHeader />
      <main>
        <HeroSection />
        <FlashFeed />
        <DeepDive />
        <ChannelGrid />
        <PusherMap />
        <VoiceWall />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}